// コラムのスライド
$(window).load(function() {
	if(navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0){
		var mySwiper = new Swiper ('.horizontal-slide', {
		  direction: 'horizontal',
		  speed: 1000,
		  width: 280,
		  spaceBetween: 25,
		  freeMode: true,
		  pagination: {
			el: ".swiper-pagination-tab",
			clickable: true,
			type: 'fraction',
		  },
		})
	}
});

// トップページ 特集検索タブ
$(function(){
	$('.btn_tab li').click(function(){
		var areaIndex = $(this).index()+1;
		$('.container_tab > li').hide();

		$('.btn_tab li').removeClass('active');
		$('.container_tab > li').removeClass('active');

		$(this).addClass('active');
		$('.container_tab #tab' + areaIndex).addClass('active').fadeIn();
	})
});

